import { connect } from 'react-redux';
import authCompany from 'store/selectors/authCompany';
import populateTimeTrackerLog from 'store/selectors/populateTimeTrackerLog';

const mapStateToProps = state => ({
  isCompanyLoaded: !!authCompany(state),
  timeTrackerLog: populateTimeTrackerLog(state),
  authCompany: authCompany(state),
  locale: state.i18n.locale,
});

const mapDispatchToProps = () => ({
  actions: {},
});

export default connect(mapStateToProps, mapDispatchToProps);
